<template>
	<div class="form-input">
		<!-- Text block w/ label -->
		<div class="input-block">
			<input
				:id="_uid"
				ref="item"
				:name="name"
				:value="val"
				:v-model="value"
				@input="update()"
				:disabled="disabled"
				:checked="value == val"
				type="radio"
				required
			/>
			<label :for="_uid" v-if="$slots.default"><slot /></label>
			<label :for="_uid" class="bold" v-else-if="title.length > 0">{{ title }}</label>
		</div>
	</div>
</template>

<script>
export default {
	name: "FormRadio",
	props: {
		// Value is the passed in selected value
		value: {
			default: false,
		},
		// Val is the radio button value
		val: {
			default: false,
		},
		required: {
			default: false,
		},
		disabled: {
			default: false,
		},
		title: {
			default: "",
		},
		name: {
			default: "input",
		},
		hint: {
			default: "",
		},
	},
	methods: {
		update() {
			this.$emit("input", this.val);
		},
	},
};
</script>

<style scoped lang="scss">
.input-block {
	position: relative;
	color: #919eab;
	cursor: pointer;
	padding-left: 25px;
}
label {
	cursor: pointer;
	width: 100%;
	margin-top: 0;
	margin-bottom: 5px;
	margin-left: 7px;
}
label.bold {
	font-family: "proximanova-bold";
	line-height: 30px;
}
input {
	cursor: pointer;
	position: absolute;
	z-index: 20;
	display: block;
	margin: 0;
	height: 26px;
	width: 26px;
	left: 0px;
}
input:focus {
	outline: 0px;
}
</style>
